import naja from 'naja'
import netteForms from 'nette-forms';
import {showFormErrors} from './naja/netteForms';
import loader from './loader';
import {reloadGridDetailContent} from "../grid/detail";

let init = function() {
	// naja.registerExtension(FormsDisable);
	naja.uiHandler.selector = '[naja]';

	naja.initialize({
		history: false,
		forceRedirect: true
	});

	netteForms.initOnLoad();
	naja.formsHandler.netteForms = netteForms;
	naja.formsHandler.netteForms.showFormErrors = showFormErrors;

	naja.snippetHandler.addEventListener('afterUpdate', (event) => {
		handleComponents($(event.detail.snippet));
	});

	naja.addEventListener('success', (event) => {
		if (event.detail.payload.type && event.detail.payload.type === 'emailPreview') {
			var win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=3000");
			win.document.body.innerHTML = event.detail.payload.body;
		}

		if (event.detail.request.method === 'POST' && event.detail.payload.result === true && !event.detail.options.gridForm) {
			staticNotification.success('Operace úspěšně dokončena.');
		}

		if (event.detail.payload.reload === 'reload-detail') {
			reloadGridDetailContent();
		}

		if (event.detail.payload.reload === 'close-modal') {
			$("[data-role=window]").data("kendoWindow").close();
		}

		if (event.detail.payload.reload === 'reload') {
			window.location.reload();
		}

		if (event.detail.request.method === 'POST' && event.detail.payload.result === false && !event.detail.options.gridForm) {
			if (typeof event.detail.payload.errorMessage !== 'undefined') {
				staticNotification.error(event.detail.payload.errorMessage);
			} else {
				staticNotification.error('Operaci se nepodařilo provést, opakujte akci prosím později.');
			}
		}
	});

	naja.addEventListener('error', (event) => {
		console.log(event.detail.error);
	});

	naja.uiHandler.addEventListener('interaction', (event) => {
		const {element} = event.detail;
		const question = element.dataset.najaconfirm;
		if (question && ! window.confirm(question)) {
			event.preventDefault();
		}
	});

	window.najaGlobal = naja;
	loader.init();
};

let getNaja = function() {
	return window.najaGlobal;
};

export default {
	init: init,
	getNaja: getNaja
};